import { render } from "./SitesList.vue?vue&type=template&id=56c8409f&scoped=true"
import script from "./SitesList.vue?vue&type=script&lang=js"
export * from "./SitesList.vue?vue&type=script&lang=js"

import "./SitesList.vue?vue&type=style&index=0&id=56c8409f&scoped=true&lang=scss"

import exportComponent from "/home/itube/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c8409f"]])

export default __exports__